// extracted by mini-css-extract-plugin
export default {"logo":"Logo_logo__CRVTg","icon":"Logo_icon__ngjDU","text":"Logo_text__4rLxt"};